import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import parse from 'html-react-parser'
import Modal from 'react-overlays/Modal'
import services from '../../services'
import APIURL from '../../../constants/APIURL'

const backdropStyle = {
  position: 'fixed',
  zIndex: 1040,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: '#000',
  opacity: 0.5
}

const modalStyle = {
  position: 'fixed',
  width: '600px',
  zIndex: 1040,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: 'white',
  boxShadow: '0 5px 15px rgba(0,0,0,.5)',
  padding: '20px',
  borderRadius: '8px',
  maxHeight: '90vh',
  overflowY: 'auto'
}

const ModalAd = ({ modal, onInteraction }) => {
  const [isMobile, setIsMobile] = useState(false)
  const [show, setShow] = useState(true)
  const [hasInteracted, setHasInteracted] = useState(false)

  useEffect(() => {
    const resize = () => {
      setIsMobile(window.innerWidth <= 760)
    }
    resize()
    window.addEventListener('resize', resize)
    return () => window.removeEventListener('resize', resize)
  }, [])

  useEffect(() => {
    if (modal?.id) {
      services.put_v2(APIURL.API_BANNER_VIEW(modal.id))
    }
  }, [modal])

  const handleDismiss = () => {
    if (modal?.id && !hasInteracted) {
      services.post_v2(APIURL.API_BANNER_MODAL_INTERACTION, {
        modal_id: modal.id,
        action: 'dismiss'
      })
      onInteraction?.(modal.id, 'dismiss')
    }
    setShow(false)
  }

  const handleClick = async () => {
    if (!modal?.url) return

    window.open(modal.url, '_blank', 'noopener,noreferrer')
    
    try {
      await services.post_v2(APIURL.API_BANNER_MODAL_INTERACTION, {
        modal_id: modal.id,
        action: 'click'
      })
      setHasInteracted(true)
      onInteraction?.(modal.id, 'click')
    } catch (error) {
      console.error('Error tracking modal click:', error)
    }
  }

  const renderBackdrop = (props) => {
    return <div {...props} style={backdropStyle} />
  }

  if (!show) return null

  let media_image = null
  if (isMobile && modal.mobile_media?.media) {
    media_image = modal.mobile_media.media
  } else {
    media_image = modal.media?.media
  }

  return (
    <Modal
      onHide={handleDismiss}
      style={modalStyle}
      className="modal-ad"
      aria-labelledby="modal-label"
      show={show}
      renderBackdrop={renderBackdrop}
    >
      <div>
        <CloseButton onClick={handleDismiss}>×</CloseButton>
        <ModalTitle>{modal.modal_title}</ModalTitle>
        {media_image && (
          <ModalImage
            src={media_image}
            alt={modal.media?.description || modal.media?.name || 'modal advertisement image'}
          />
        )}
        <ModalBody>{parse(modal.modal_content || '')}</ModalBody>
        <ModalFooter>
          <ModalButton onClick={handleClick} href={modal.url} target="_blank" rel="noreferrer">
            {modal.cta_text}
          </ModalButton>
        </ModalFooter>
      </div>
    </Modal>
  )
}

ModalAd.propTypes = {
  modal: PropTypes.shape({
    id: PropTypes.number,
    modal_title: PropTypes.string,
    modal_content: PropTypes.string,
    cta_text: PropTypes.string,
    url: PropTypes.string,
    media: PropTypes.object,
    mobile_media: PropTypes.object
  }).isRequired,
  onInteraction: PropTypes.func
}

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  &:hover {
    color: #000;
  }
`

const ModalImage = styled.img`
  width: 100%;
  max-height: 300px;
  object-fit: contain;
  margin-bottom: 20px;
`

const ModalTitle = styled.h2`
  margin: 0 0 15px 0;
  font-size: 24px;
  color: #333;
  text-align: center;
`

const ModalBody = styled.div`
  margin-bottom: 20px;
  color: #666;
  line-height: 1.5;
`

const ModalFooter = styled.div`
  text-align: center;
`

const ModalButton = styled.a`
  display: inline-block;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #0056b3;
  }
`

export default ModalAd
